<template>
    <div ref="sliderRef" class="main-slider" :style="{height: slideHeight + 'px'}">
        <div v-for="(slide, idx) in slider.banners" :key="slide.id" class="slide">
            <div class="slide-item" :style="{height: slideHeight + 'px'}">
                <a :href="slide.url" v-if="slide.url && slide.btn_pos === 'hidden'">
                    <img :src="slide.image_url" :alt="slide.name" loading="lazy">
                </a>
                <img v-if="!slide.url || slide.btn_pos !== 'hidden'" :src="slide.image_url" :alt="slide.name" loading="lazy">
                <div class="slide-info">
                    <div class="slide-name" v-if="slide.show_title">{{ slide.name }}</div>
                </div>
                <a :href="slide.url" class="slide-link" :class="slide.btn_pos">{{ $t('Ознайомитись') }}</a>
            </div>
        </div>
    </div>
</template>

<script setup>


import {nextTick, onMounted, ref} from "vue";

const props = defineProps({
    slider: Object
})

const sliderRef = ref();
const slideHeight = ref(450);

const onResize = () => {
    const menuCat = document.querySelector('#menu-catalog');
    if (window.outerWidth < 768) {
        slideHeight.value = (window.outerWidth / 1.8) - 30;
    } else {
        if (menuCat && menuCat.offsetHeight < 450) {
            slideHeight.value = 450
        } if (menuCat && menuCat.offsetHeight < 450) {
            slideHeight.value = menuCat.offsetHeight - 16
        } else {
            slideHeight.value = 560
        }
        // console.log("offsetHeight", menuCat?.offsetHeight)
        // console.log(slideHeight.value)
    }
}

onMounted(() => {
    onResize();

    window.addEventListener('resize', () => {
        onResize();
    })

    nextTick(() => {
        jQuery(sliderRef.value).slick({
            infinite: true,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            speed: 2000,
            dots: false,
            autoplay: true
        });
    })
})

</script>

<style scoped>

</style>
